// src/utils/socket.js
import { io } from 'socket.io-client';
import { getServerUrl } from './serverUrl';

const socket = io(getServerUrl());

export default socket;
